import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", { fill: "#252729" }, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              d: "M6.22 6.22c.293-.293.767-.293 1.06 0l5.127 5.126 5.126-5.126c.293-.293.768-.293 1.061 0 .266.266.29.683.073.976l-.073.084-5.126 5.127 5.126 5.126.073.084c.218.294.193.71-.073.977-.293.293-.768.293-1.06 0l-5.127-5.126-5.127 5.126c-.293.293-.767.293-1.06 0-.267-.266-.29-.683-.073-.977l.073-.084 5.126-5.126L6.22 7.28l-.073-.084c-.218-.293-.194-.71.073-.976z",
              transform: "translate(-331 -347) translate(0 331) translate(331 16)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }